import * as React from "react";
import Component from "../../AbstractComponent";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import Button from '@material-ui/core/Button';

export default class PropertyDetailsReadonly extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}

	public getReadonlyReason = (property: PropertyInterface) => {
		if (property?.removed) {
			return this.trans("property-readonly/removed");
		}
	}
	
  public render() {
		const property: PropertyInterface = this.props.property;
		
		return (
			<div className="charge-details-readonly">
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
					<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
						{this.trans("label-address")}
					</div>
				</div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
					<div className="counterparty">
						{`${property?.displayName}`}
					</div>
				</div>
				<table>
					<tr>
						<td className="align-left first-column">
							{`${this.trans("owner")}: `}
						</td>
						<td className="align-left">
							<div className="margin-wrapper">
								<div 
									className="link-to-entity" 
									onClick={() => this.redirect(`/app/owner/update/${property?.companyId}/`)}
								>
									{`${property?.company?.displayName}`}
								</div>
							</div>
						</td>
					</tr>
					{
						property?.complexName && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("label-complex-name")}: `}
								</td>
								<td className="align-left">
									{property?.complexName}
								</td>
							</tr>
						)
					}
					{
						property?.manager && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("dropdown-manager-label")}: `}
								</td>
								<td className="align-left">
									<div className="margin-wrapper">
										<div 
											className="link-to-entity" 
											onClick={() => this.redirect(`/app/caretaker/update/${property?.managerId}/`)}
										>
											{`${property?.manager?.displayName}`}
										</div>
									</div>
								</td>
							</tr>
						)
					}
					{
						property?.associationOwner && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("page/propertycreate-field/associationownerid-label")}: `}
								</td>
								<td className="align-left">
									<div className="margin-wrapper">
										<div 
											className="link-to-entity" 
											onClick={() => this.redirect(`/app/company/update/${property?.associationOwnerId}/`)}
										>
											{`${property?.associationOwner?.displayName}`}
										</div>
									</div>
								</td>
							</tr>
						)
					}
				</table>
				{
					property?.isReadonly && this.props.mainCardPresentation &&
						<div className="readonly-reason" style={{flexDirection: "column"}}>
							<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
								<div
									className="list-label readonly"
									style={{
										marginRight: "5px",
										maxWidth: "max-content"
									}}
								>
									{property?.isReadonly && this.trans("label-readonly")}
								</div>
								<div>{this.getReadonlyReason(property)}</div>
							</div>
						</div>
				}
				{
					!this.props.mainCardPresentation && (
						<div style={{marginTop: "10px", display: "flex", justifyContent: "flex-start"}}>
							<Button 
								variant="outlined"
								color="primary"
								onClick={() => this.redirect(`/app/property/update/${property?.id}`)}
							>
								{this.trans("button-open")}
							</Button>
						</div>
					)
				}
			</div>
		);
  }
}
